import { AdditionalFieldDefinitionHelper } from "./interfaces/additional-field-definition-helper";

export class AdditionalFieldCheckboxHelper implements AdditionalFieldDefinitionHelper {
  public getValue(item: any): any {
    return item.Value;
  }
}
